module.exports = __webpack_public_path__ + "img/fifth.9fb3bb0e.png";